import { isMobile } from '@Constants/LeftDrawer';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ScrollView, StyleSheet } from 'react-native';
import styled from 'styled-components/native';

import { Text } from '../../../Common/Text';
import { StyledCardContent } from '../SeenThings';
import { useSeenThingsPresenter } from '../SeenThingsPresenter';
import SeenThingsCard from './ProductCard';

const StyledDateText = styled.View`
  margin: 20px 0 15px;
`;

const SeenThingsByDate = () => {
  const { productsByDate } = useSeenThingsPresenter();
  return (
    <ScrollView contentContainerStyle={styles.scroll}>
      <StyledCardContent>
        {productsByDate?.map((s) => (
          <ScrollView key={s.date}>
            <StyledDateText>
              <Text
                fontStyleOverride={{
                  fontSize:
                    OwnableTheme.fontSizesNumerical[isMobile ? 'xxxs' : 's'],
                  color: OwnableTheme.colors.gray,
                  fontFamily: OwnableTheme.fonts.gilroy.regular,
                }}
              >
                {`${s.date.split('2023')[0]}`}
              </Text>
            </StyledDateText>
            <StyledCardContent>
              {s.products.map((p) => (
                <SeenThingsCard
                  url={p.productImage}
                  path={p.path}
                  key={p.productImage}
                />
              ))}
            </StyledCardContent>
          </ScrollView>
        ))}
      </StyledCardContent>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scroll: {
    paddingVertical: isMobile ? 18 : 33,
    paddingHorizontal: isMobile ? 35 : 60,
  },
});

export default observer(SeenThingsByDate);
